"use strict";

var cov_2e26yv40ng = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/index.js";
  var hash = "3eb33d478f16a1b384779d1fcba548630bdcd640";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3eb33d478f16a1b384779d1fcba548630bdcd640"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Repository: true,
  useRepository: true
};
Object.defineProperty(exports, "Repository", {
  enumerable: true,
  get: function get() {
    return _Repository2.default;
  }
});
Object.defineProperty(exports, "useRepository", {
  enumerable: true,
  get: function get() {
    return _useRepository.default;
  }
});

var _crud = require("./crud");

Object.keys(_crud).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _crud[key];
    }
  });
});

var _Repository = require("./Repository.context");

Object.keys(_Repository).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Repository[key];
    }
  });
});

var _zipCore = require("./zip-core");

Object.keys(_zipCore).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _zipCore[key];
    }
  });
});

var _helpers = require("./helpers");

Object.keys(_helpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _helpers[key];
    }
  });
});

var _Repository2 = _interopRequireDefault(require("./Repository"));

var _useRepository = _interopRequireDefault(require("./useRepository"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}